/**
 * Complementary Exams Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";

// States
const state = {
    complementaryExams: [],
    complementaryExam: {}
};

// Getters
const getters = {
    complementaryExams: state => {
        return state.complementaryExams
    },

    complementaryExam: state => {
        return state.complementaryExam
    }
};

// Actions
const actions = {
    getComplementaryExams(context, payload) {
        function successCallback(response) {
            context.commit('getComplementaryExamsHandler', { complementaryExams: response.data.examensComplementaire });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Complementary.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getComplementaryExam(context, payload) {
        function successCallback(response) {
            context.commit('getComplementaryExamHandler', { complementaryExam: response.data.examenComplementaire });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Complementary.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createComplementaryExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'complementary-exams' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Complementary.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateComplementaryExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'complementary-exams' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Complementary.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteComplementaryExam(context, payload) {
        function successCallback(response) {
            context.commit('deleteComplementaryExamHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Complementary.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getComplementaryExamsHandler(state, { complementaryExams }) {
        // Update complementaryExamms state
        state.complementaryExams = complementaryExams;
    },

    getComplementaryExamHandler(state, { complementaryExam }) {
        // Update complementaryExam state
        state.complementaryExam = complementaryExam;
    },

    deleteComplementaryExamHandler(state, { index, successMessage }) {
        let i = state.complementaryExams.findIndex(complementaryExam => complementaryExam.slug === index);

        if (~i) {
            state.complementaryExams.splice(i, 1);

            router.push({ name: 'complementary-exams' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}